export const ANNOTATION_SOURCE_KEY = '__source';

export const PNID_ANNOTATION_TYPE = 'pnid_annotation';
